<template>
  <div class="wrap">
    <div class="user-info flex">
      <div class="img-box">
        <img :src="headPicUrl">
      </div>
      <div class="info-txt flex-1">
        <h2>{{ userName }}</h2>
        <!-- <span>{{className}}</span> -->
      </div>
    </div>
    <div class="manage">
      <ul class="flex flex-wrap">
        <!-- <router-link :to="{name: item.routerGo, query: { type: userTypeName, userId: id , msgCount: item.messageTotal}}" tag="li" v-for="item in appList" :key="item.appId"> 
                    <div class="manage-item">
                        <i class="notice-status" v-if="item.messageTotal != 0" >{{ item.messageTotal }}</i>
                        <img :src="item.homeIconMT">
                        <p>{{item.appName}}</p>
                    </div>
                </router-link> -->

        <li @click="skipApp(userTypeName, id, item)" v-for="item in appList" :key="item.appId" v-if="item.showFlag">
          <div class="manage-item">
            <i class="notice-status" v-if="item.messageTotal != 0">{{ item.messageTotal }}</i>
            <img :src="item.homeIconMT">
            <p>{{ item.appName }}</p>
          </div>
        </li>
        <!-- <li @click="skipAp">
                    <div class="manage-item">
                        <i class="notice-status"></i>
                        <img >
                        <p>新综合素质评价</p>
                    </div>
                </li> -->

        <router-link :to="{ name: 'Ucenter', query: { id: id } }" tag="li">
          <div class="manage-item">
            <div class="item-contacts">
              <span class="iconfont icon-user"></span>
            </div>
            <p>个人中心</p>
          </div>
        </router-link>

        <!-- <router-link :to="{ name: 'Data-center' }" tag="li">
          <div class="manage-item">
            <div class="item-contacts">
              <span class="iconfont icon-user"></span>
            </div>
            <p>数据中心</p>
          </div>
        </router-link> -->
      </ul>
    </div>
  </div>
</template>


<script>
import { getUserInfo } from "@/service/user-service";
import default_avatar from "@/assets/images/user.png?20241114";
// const ip = require("ip");
// const IP = ip.address();
export default {
  data() {
    return {
      userName: '',
      userType: "",
      schoolId: "",
      userTypeName: 'student',
      headPicUrl: default_avatar,
      childrenName: '',
      className: '',
      id: 0,
      appList: [],
      isAdmin: 0,
      gradeId: '',
      sessionid: this.$route.query.sessionid,
      appId: this.$route.query.appId,
      userId: this.$route.query.userId,
      type: this.$route.query.type,
      msgCount: this.$route.query.msgCount,
      route: this.$route.query.route,
    }
  },
  mounted() {

    this.$nextTick(() => {
      if (this.sessionid) {
        // document.cookie = "SESSION=" + this.sessionid + "; path=/";
        this.$http
          .get("api/mobile/user/loginbindBysessionid?sessionid=" + this.sessionid)
          .then((res) => {
            this.getUser();
          });
      } else {
        this.$http
          .post("api/mobile/user/judgeBindWechat", {
            // ip: IP,
            loginType: "wechat",
            wechat: "",
          })
          .then((res) => {
            if (res.data.code == 0) {
              if (!res.data.isHaveBind) {
                this.$router.replace({ name: "Login" });
                return;
              }
            }
          });
        this.getUser();
      }
    });
  },
  methods: {
    // skipAp(){
    //    this.$router.push({path:"/student/stu-details"})
    // },
    getUser() {
      getUserInfo().then((user) => {
        if (user.code == 0) {
          if (
            this.userId &&
            this.type &&
            this.msgCount &&
            this.route
          ) {
            this.$router.push({
              path: this.route,
              query: {
                id: this.userId,
                type: this.type,
                msgCount: this.msgCount,
                appId: this.appId,
                sessionid: this.sessionid,
              },
            });
            return false;
          }
          if (user.user.isForcedUpw == "true") {
            this.$router.push({
              path: "/changePwd",
              query: { userId: user.userId },
            });
            return false;
          }
          this.userType = user.user.userType;
          this.schoolId = user.user.schoolId;
          this.id = user.user.userId;
          this.userName = user.userName;
          this.isAdmin = user.user.isAdmin;
          this.gradeId = user.gradeId;
          var pred = this.userType == "3" || this.userType == "5";
          if (pred) {
            this.userTypeName = "student";
          } else if (!pred || user.user.isAdmin != 1) {
            this.userTypeName = "teacher";
          } else {
            this.userTypeName = "admin";
          }
          this.headPicUrl = user.headPicUrl || default_avatar;
          this.childrenName = user.childrenName;
          this.className = user.className;
          this.getApp();
        } else if (user.code == 1) {
          this.$router.replace({ name: "Login" });
        } else {
          alert(user.message);
          this.$router.replace({ name: "Login" });
        }
      });
    },
    getApp() {
      this.$http.get('api/mobile/school/getSchoolApp').then(res => {

        if (res.data.code == 0) {
          // _.each(res.data.data, item => {
          //     if(item.appId == 46) {
          //         try {
          //             let account = JSON.parse(localStorage.getItem('account_info'));
          //             let url = '?userName=' + account.userName + '&password=' + account.password;
          //             item.appUrl += url;

          //         } catch (error) {
          //              console.log("Uncaught ReferenceError: localStorage ==> account_info is not defined");
          //         }
          //     }
          // });
          // localStorage.getItem('')
          this.appList = res.data.data;
          var pred = this.userType == "3" || this.userType == "5";
          this.appList.forEach(item => {
            item.showFlag = true;
            if (item.appConfig && item.appId == 4 && pred) {
              let appConfig = JSON.parse(item.appConfig)
              let gradeArr = appConfig.oldGrade;
              gradeArr.push(...appConfig.newGrade);
              item.grades = gradeArr.join(',');
              item.showFlag = item.grades.includes(this.gradeId);
            }
          })
          // console.log(this.appList)

          // this.appList = _.map(res.data.data, item => {
          //     let pred = this.userType == "3" || this.userType == "5";

          // if (appType == "4") {//请求linkApp
          // this.$router.replace({path: '/mobile/school/linkApp?' + item.appId});

          // } else if (item.appType == '2') {//直接跳转路径http://.....
          //     // appUrlMT
          //     this.$router.replace({path: appUrlMT});
          // }
          //         if(pred) {
          //             item.routerGo = item.studentUrlMT;
          //         } else if(!pred || this.isAdmin !=1) {
          //             item.routerGo = item.teacherUrlMT;
          //         } else {
          //             item.routerGo = 'Assess-admin';
          //         }
          //         return item;
          //     })
          // } else if(res.data.code == 1) {
          //     alert('会话超时,请重新登录!');
          //     this.$router.replace({ name: 'Login' });
          // } else {
          //     alert(res.data.message);
        }
      });
    },
    skipApp(type, userId, item) {
      let pred = this.userType == "3" || this.userType == "5";
      if (item.appType == '4') {
        let val = { appId: item.appId };
        // if(item.appId == 42) {
        //     let account = JSON.parse(localStorage.getItem('account_info'));
        //     val.userName = account.userName;
        //     val.password = account.password;
        // }
        this.$http.get('/api/mobile/school/linkApp', {
          params: val
        }).then(res => {
          if (res.data.code == 0) {
            window.location.href = res.data.data;
          }
        })
      } else if (item.appType == '2') {

        this.$router.push({
          path: item.appUrlMT
        })
      } else {

        if (pred) {
          sessionStorage.setItem('appConfig', JSON.stringify(item.appConfig))
          this.$router.push({
            name: item.studentUrlMT,
            query: { id: userId, type: type, msgCount: item.messageTotal }
          })
        } else if (item.appId == '27' && this.isAdmin == 1) {

          this.$router.push({
            name: 'Assess-admin',
            query: { id: userId, type: type, msgCount: item.messageTotal }
          })
        } else {

          this.$router.push({
            name: item.teacherUrlMT,
            query: { id: userId, type: type, msgCount: item.messageTotal }
          })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home.vue